export default __webpack_public_path__ + "static/media/image.electroleaf-pvt-ltd.3af45c0c.png";